import type React from 'react'
import type { IconProps } from '../icons/types'
import { cn } from '../lib/cva'
import { Text } from './Text'

type AlertVariant = 'error' | 'info'

interface AlertProps {
	message?: React.ReactNode
	children?: React.ReactNode
	icon?: React.FC<IconProps>
	variant?: AlertVariant
	className?: string
}

const variantStyles: Record<AlertVariant, { container: string; icon: string; text: string }> = {
	error: {
		container: 'bg-error-100 border-error-300',
		icon: 'text-error-600',
		text: 'text-error-700',
	},
	info: {
		container: 'bg-primary-100 border-primary-300',
		icon: 'text-primary-600',
		text: 'text-primary-800',
	},
}

export const Alert: React.FC<AlertProps> = ({ message, children, icon: Icon, variant = 'error', className }) => {
	const styles = variantStyles[variant]
	const content = children ?? message

	return (
		<div className={cn('border rounded-lg px-4 py-4 flex items-center gap-2 w-fit', styles.container, className)}>
			{Icon && <Icon className={cn('w-5 h-5', styles.icon)} />}
			{typeof content === 'string' || typeof content === 'number' ? (
				<Text variant='small' weight='regular' className={styles.text}>
					{content}
				</Text>
			) : (
				content
			)}
		</div>
	)
}
